import { Checkbox as FormCheckbox } from "components/shared/form";

export default class Checkbox extends FormCheckbox {
    render() {
        return this.renderField();
    }
}
